import { render } from "./DisciplineFormView.vue?vue&type=template&id=6612696c&scoped=true"
import script from "./DisciplineFormView.vue?vue&type=script&lang=js"
export * from "./DisciplineFormView.vue?vue&type=script&lang=js"

import "./DisciplineFormView.vue?vue&type=style&index=0&id=6612696c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6612696c"]])

export default __exports__